import { LAYOUTS, POSITION, } from "@voltmoney/types";
import { ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../../routes";
import { ACTION } from "./types";
import { ClearSearchPortfolio, closePopup, EditItem, getTotalLimit, goBack, needHelp, SearchPortfolio, ToggleSelectAction, TriggerCTA, } from "./actions";
import SharedPropsService from "../../../SharedPropsService";
import { portfolioListDatastoreBuilderV2 } from "./utils";
import { addCommasToNumber, roundDownToNearestHundred } from "../../../configs/utils";
import { Platform } from "react-native";
import { isDarkModeTheme } from "../../../configs/config";
let isDarkMode = isDarkModeTheme();
export const template = async (stepResponseObject, totalCreditAmount, minimumAmount) => {
    return {
        layout: {
            id: ROUTE.PORTFOLIO,
            type: LAYOUTS.LIST,
            widgets: [
                Platform.OS === "ios" ? { id: "spaceXXL", type: WIDGET.SPACE, position: POSITION.ABSOLUTE_TOP } : {},
                { id: "customHeader", type: WIDGET.CUSTOM_HEADER, position: POSITION.ABSOLUTE_TOP },
                { id: "space0", type: WIDGET.SPACE, position: POSITION.ABSOLUTE_TOP },
                { id: "titleText", type: WIDGET.TEXT },
                { id: "space0", type: WIDGET.SPACE },
                { id: "subTitleText", type: WIDGET.TEXT },
                { id: "col1Space", type: WIDGET.SPACE },
                { id: "infoRow", type: WIDGET.STACK },
                { id: "space2", type: WIDGET.SPACE },
                { id: "divider0", type: WIDGET.DIVIDER },
                { id: "listItem", type: WIDGET.LIST },
                { id: "listSpace", type: WIDGET.SPACE },
                { id: "divider1", type: WIDGET.DIVIDER, position: POSITION.ABSOLUTE_BOTTOM },
                {
                    id: "totalItem",
                    type: WIDGET.STACK,
                    position: POSITION.ABSOLUTE_BOTTOM,
                },
            ],
        },
        datastore: {
            customHeader: {
                title: "Set credit limit",
                needHelpAction: {
                    routeId: ROUTE.PORTFOLIO,
                    type: ACTION.NEED_HELP,
                    payload: {
                        id: "btn_portfolioV2_needHelp"
                    }
                },
                isDarkMode: isDarkMode ? true : false,
                goBackAction: {
                    routeId: ROUTE.PORTFOLIO,
                    type: ACTION.BACK_BUTTON,
                    payload: {
                        id: "btn_portfolioV2_goBack"
                    }
                },
                skipAndroidExit: true
            },
            headerDivider: {
                size: DividerSizeTokens.SM,
                color: ColorTokens.Grey_Milk_1
            },
            spaceXXL: {
                size: SizeTypeTokens.XXL
            },
            titleText: {
                label: "Select mutual funds for pledging",
                fontSize: FontSizeTokens.MD,
                fontFamily: FontFamilyTokens.Poppins,
                fontWeight: "700",
                color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night,
                lineHeight: 24,
            },
            space0: { size: SizeTypeTokens.MD },
            space1: { size: SizeTypeTokens.LG },
            space2: { size: SizeTypeTokens.LG },
            subTitleText: {
                label: `₹${addCommasToNumber(await SharedPropsService.getDesiredPortfolio())} out of ₹${addCommasToNumber(parseInt(stepResponseObject["totalPortfolioAmount"].toString()))} are selected for pledging.`,
                fontSize: FontSizeTokens.SM,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: "400",
                color: isDarkMode ? ColorTokens.DARK_GREY_THEME : ColorTokens.Grey_Charcoal,
                lineHeight: 24,
            },
            divider0: {
                size: DividerSizeTokens.MD,
                type: "solid",
                color: ColorTokens.Grey_Milk_1,
            },
            divider1: {
                size: DividerSizeTokens.MD,
                type: "solid",
                color: ColorTokens.Grey_Milk_1,
            },
            inputItem: {
                type: InputTypeToken.SEARCH,
                state: InputStateToken.DEFAULT,
                placeholder: "Search Portfolio",
                title: "",
                caption: { success: "", error: "" },
                keyboardType: KeyboardTypeToken.default,
                action: {
                    type: ACTION.SEARCH_PORTFOLIO,
                    payload: {
                        value: "",
                        widgetId: "listItem",
                        stepResponseObject,
                    },
                    routeId: ROUTE.PORTFOLIO,
                },
                clearAction: {
                    type: ACTION.CLEAR_SEARCH_PORTFOLIO,
                    routeId: ROUTE.PORTFOLIO,
                    payload: {},
                },
            },
            inputSpace: { size: SizeTypeTokens.XL },
            listSpace: { size: SizeTypeTokens.XS },
            ...(await portfolioListDatastoreBuilderV2(stepResponseObject, '', totalCreditAmount, minimumAmount)),
            infoRow: {
                type: StackType.row,
                justifyContent: StackJustifyContent.spaceBetween,
                alignItems: StackAlignItems.center,
                padding: {
                    horizontal: SizeTypeTokens.XS,
                    vertical: SizeTypeTokens.XS,
                },
                widgetItems: [
                    { id: "col1Header", type: WIDGET.TEXT },
                    { id: "col2Headers", type: WIDGET.STACK },
                ],
            },
            col2Headers: {
                type: StackType.row,
                padding: {
                    horizontal: SizeTypeTokens.XS,
                    right: SizeTypeTokens.XXXXL
                },
                widgetItems: [
                    { id: "col2Header", type: WIDGET.TEXT },
                ],
            },
            col1Space: {
                size: SizeTypeTokens.XXXL,
            },
            col2Space: {
                size: SizeTypeTokens.XXXXL,
            },
            col1Header: {
                label: "Mutual fund",
                fontSize: FontSizeTokens.XS,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: "500",
                color: ColorTokens.Grey_Charcoal,
                lineHeight: 18,
            },
            col2Header: {
                label: Platform.OS !== "web" ? "Credit limit  " : "Credit limit",
                fontSize: FontSizeTokens.XS,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: "500",
                color: ColorTokens.Grey_Charcoal,
                lineHeight: 18,
            },
        },
    };
};
export const portfolioMFV2 = {
    onLoad: async ({}, { stepResponseObject, updateAvailableCASMap }) => {
        await SharedPropsService.setAvailableCASMap(updateAvailableCASMap);
        const minimumEligibleLimit = await SharedPropsService.getMinimumEligibleLimitData();
        //@ts-ignore
        const minimumAmount = minimumEligibleLimit?.amount;
        const totalCreditAmount = roundDownToNearestHundred(getTotalLimit(stepResponseObject.availableCAS, stepResponseObject.isinNAVMap, stepResponseObject.isinLTVMap));
        return Promise.resolve(await template(stepResponseObject, totalCreditAmount, minimumAmount));
    },
    actions: {
        [ACTION.PORTFOLIO]: TriggerCTA,
        [ACTION.SEARCH_PORTFOLIO]: SearchPortfolio,
        [ACTION.CLEAR_SEARCH_PORTFOLIO]: ClearSearchPortfolio,
        [ACTION.BACK_BUTTON]: goBack,
        [ACTION.TOGGLE_ITEM]: ToggleSelectAction,
        [ACTION.EDIT_ITEM]: EditItem,
        [ACTION.NEED_HELP]: needHelp,
        [ACTION.CLOSE_POPUP]: closePopup,
    },
    clearPrevious: true,
};
